import React from "react";
import { FormSelect } from "../inputs";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

const SelectPayment = ({ next, back }) => {
  const { t } = useTranslation();
  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    watch,
  } = useForm();

  const onSubmit = () => {
    next();
  };
  return (
    <form className="additional-info w40 ml3" onSubmit={handleSubmit(onSubmit)}>
      <h3>Select Payment</h3>
      <div className="pp-form-item">
        <label style={{ color: "#3B3B3B" }}>
          Receive Interest or Maturity Amount
        </label>
        <div style={{ display: "flex", gap: "10px" }}>
          <button className="send-btn">Current/Savings Account</button>
          <button className="back-btn">Other Banks</button>
        </div>
      </div>
      <div className="pp-form-item">
        <label style={{ color: "#3B3B3B" }}>Pay Via</label>
        <div style={{ display: "flex", gap: "10px" }}>
          <button className="send-btn">Current/Savings Account</button>
          <button className="back-btn">Other Banks</button>
        </div>
      </div>

      <div className="pp-form-item">
        <FormSelect
          inline
          control={control}
          {...register("account")}
          errors={errors}
          label={t("Select Account")}
          options={[]}
          hideCreateOption={true}
          required={true}
        />
      </div>

      <div className="pp-form-item">
        <label>Branch</label>
        <p
          style={{
            fontWeight: 600,
            fontSize: 16,
          }}
        >
          Jubilee Hills Branch, Hyderabad
        </p>
      </div>

      <div className="mt3">
        <button type="button" className="back-btn mr2" onClick={() => back()}>
          Back
        </button>
        <button className="send-btn">Proceed</button>
      </div>
    </form>
  );
};

export default SelectPayment;
